export default "__VITE_ASSET__SSdaDo73__"